import {makeAutoObservable} from 'mobx';
import LessonContentRepository from '../../../../data/repositories/LessonContentRepository';
import {
  CHALLENGE_BRANCH_QUESTION,
  LessonContentChallengeBranchQuestion,
} from '../../../../data/models/LessonContent/LessonContentBase';

class AddChallengeBranchQuestionStore {
  private lessonContentRepo = new LessonContentRepository();
  private isOpen = false;
  private parentId?: string = undefined;
  private onCreateCallback?: () => void;

  public isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  public isWizardOpen() {
    return this.isOpen && this.parentId;
  }

  public closeWizard() {
    this.isOpen = false;
    this.parentId = undefined;
    this.onCreateCallback = undefined;
  }

  public openWizard(parentId: string, onCreateCallback?: () => void) {
    this.parentId = parentId;
    this.isOpen = true;
    this.onCreateCallback = onCreateCallback;
  }

  public async createQuestion(
    organizationId: string,
    lessonId: string,
    question: string,
    gradeWeight: number,
  ) {
    if (this.parentId) {
      this.isLoading = true;
      const result = await this.lessonContentRepo.addLessonContent(
        organizationId,
        lessonId,
        {
          data: {
            ivNodeType: CHALLENGE_BRANCH_QUESTION,
            question,
            gradeWeight,
          } as LessonContentChallengeBranchQuestion,
          parentsIds: [this.parentId],
        },
      );
      this.isLoading = false;
      if (result.success && this.onCreateCallback) {
        this.onCreateCallback();
        this.closeWizard();
      }
    }
  }
}

export default AddChallengeBranchQuestionStore;
